export const PERSISTENCE_VERSION = 2;
export const PERSISTENCE_VERSION_KEY = 'vmp-redux-persistence-version';

export const LEGACY_PERSIST_KEYS = Object.freeze([
    'persist:root',
    'persist:currentUser',
    'persist:theme',
    'persist:userInfo',
    'persist:subInfo',
    'persist:packageManagement',
    'persist:auth',
    'persist:userInfoSSO',
]);

export const USER_SCOPED_PERSIST_KEYS = Object.freeze([
    'persist:currentUser',
    'persist:userInfo',
    'persist:subInfo',
    'persist:packageManagement',
    'persist:auth',
    'persist:userInfoSSO',
]);

const safeParse = (value) => {
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(value);
    } catch (_) {
        return undefined;
    }
};

const readPersistedState = (targetStorage, key) =>
    safeParse(targetStorage.getItem(key)) || {};

const readPersistedField = (persistedState, key) =>
    safeParse(persistedState[key]);

const serializePersistedState = (state) => JSON.stringify({
    ...Object.entries(state).reduce((result, [key, value]) => ({
        ...result,
        [key]: JSON.stringify(value),
    }), {}),
    _persist: JSON.stringify({ version: PERSISTENCE_VERSION, rehydrated: true }),
});

export const purgeUserPersistedStorage = (targetStorage = window.localStorage) => {
    USER_SCOPED_PERSIST_KEYS.forEach((key) => targetStorage.removeItem(key));
};

export const migratePersistedStorage = (targetStorage = window.localStorage) => {
    const currentVersion = Number(targetStorage.getItem(PERSISTENCE_VERSION_KEY) || 0);
    if (currentVersion === PERSISTENCE_VERSION) return false;

    const legacyTheme = readPersistedState(targetStorage, 'persist:theme');
    const initialConfig = readPersistedField(legacyTheme, 'initialConfig');
    const isVMPTheme = readPersistedField(legacyTheme, 'isVMPTheme');

    LEGACY_PERSIST_KEYS.forEach((key) => targetStorage.removeItem(key));
    
    if (initialConfig || typeof isVMPTheme === 'boolean') {
        targetStorage.setItem(
            'persist:theme',
            serializePersistedState({
                ...(initialConfig ? { initialConfig } : {}),
                ...(typeof isVMPTheme === 'boolean' ? { isVMPTheme } : {}),
            }),
        );
    }
    targetStorage.setItem(PERSISTENCE_VERSION_KEY, String(PERSISTENCE_VERSION));
    return true;
};
